import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const GovernmentStandards = () => {
  const knowledgeBases = [
    {
      title: "Federal Building Standards Integration API",
      description: "API framework for integrating multiple government building standards into design workflows",
      type: "API",
      lastUpdated: "2024-02-01"
    },
    {
      title: "GSA Design Standards Repository",
      description: "Centralized repository of all GSA design standards and specifications",
      type: "Repository",
      lastUpdated: "2024-02-18"
    },
    {
      title: "Automated Compliance Checking Tools",
      description: "Tools for automatically checking design compliance with government standards",
      type: "Tool",
      lastUpdated: "2024-01-28"
    },
    {
      title: "Standards Integration Workflow",
      description: "Standardized workflow for incorporating government standards into design processes",
      type: "Workflow",
      lastUpdated: "2024-02-12"
    },
    {
      title: "Multi-Agency Standards Reconciliation",
      description: "Framework for reconciling conflicting standards across different federal agencies",
      type: "Framework",
      lastUpdated: "2024-02-05"
    }
  ];

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <Link to="/gsa-channel" className="inline-flex items-center text-primary hover:text-primary/80 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to GSA Channel
          </Link>
          <h1 className="text-3xl font-bold mb-2">Government Standards Integration Framework</h1>
          <p className="text-muted-foreground">
            Comprehensive framework and tools for integrating government building standards into federal design and construction processes.
          </p>
        </div>

        <div className="grid gap-6">
          {knowledgeBases.map((kb, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{kb.title}</CardTitle>
                    <p className="text-muted-foreground">{kb.description}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                      {kb.type}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Updated: {kb.lastUpdated}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex gap-3">
                  <Button variant="outline" size="sm">
                    <FileText className="h-4 w-4 mr-2" />
                    View Details
                  </Button>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default GovernmentStandards;